var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12 scope-apply-base-style scope-min-height" },
    [
      _c("transition", { attrs: { name: "slide-fade" } }, [
        !_vm.loading && _vm.showAdvancedOptions
          ? _c(
              "div",
              {
                staticClass: "container-fluid",
                attrs: { id: "advanced-options-container" }
              },
              [
                _c(
                  "div",
                  { staticClass: "row scoped-tablist-container" },
                  [
                    _vm.showSubquestionEdit || _vm.showAnswerOptionEdit
                      ? [
                          _c(
                            "ul",
                            {
                              staticClass:
                                "nav nav-tabs scoped-tablist-subquestionandanswers",
                              attrs: { role: "tablist" }
                            },
                            [
                              _vm.showSubquestionEdit
                                ? _c(
                                    "li",
                                    {
                                      class:
                                        _vm.currentTabComponent ==
                                        "subquestions"
                                          ? "active"
                                          : ""
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              $event.stopPropagation()
                                              return _vm.selectCurrentTab(
                                                "subquestions"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("translate")(
                                                "subquestions"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.showAnswerOptionEdit
                                ? _c(
                                    "li",
                                    {
                                      class:
                                        _vm.currentTabComponent ==
                                        "answeroptions"
                                          ? "active"
                                          : ""
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              $event.stopPropagation()
                                              return _vm.selectCurrentTab(
                                                "answeroptions"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("translate")(
                                                "answeroptions"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      : _vm._e(),
                    !_vm.hideAdvancedOptions
                      ? _c(
                          "ul",
                          {
                            staticClass:
                              "nav nav-tabs scoped-tablist-advanced-settings",
                            attrs: { role: "tablist" }
                          },
                          _vm._l(_vm.tabs, function(advancedSettingCategory) {
                            return _c(
                              "li",
                              {
                                key: "tablist-" + advancedSettingCategory,
                                class:
                                  _vm.$store.state
                                    .questionAdvancedSettingsCategory ==
                                    advancedSettingCategory &&
                                  _vm.currentTabComponent == "settings-tab"
                                    ? "active"
                                    : ""
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        return _vm.selectCurrentTab(
                                          "settings-tab",
                                          advancedSettingCategory
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(advancedSettingCategory))]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "row scope-border-open-top" },
                  [
                    _c(_vm.currentTabComponentComputed, {
                      tag: "component",
                      attrs: { event: _vm.event, readonly: _vm.readonly },
                      on: {
                        eventSet: _vm.eventSet,
                        triggerEvent: _vm.triggerEvent
                      }
                    })
                  ],
                  1
                )
              ]
            )
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.loading
          ? _c("div", { staticClass: "container-fluid" }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("loader-widget", {
                    attrs: { id: "advanced-panel-loader" }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }